module.exports = __webpack_public_path__ + "img/ceramic-teal.09522f02.webp";